/* Vidéos des sections copiées : charge les sources data-src et lance la lecture muette. */
(function () {
  function load(v) {
    v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
    v.load();
    var box = v.closest('internal-video');
    if (!box || box.dataset.autoplay === 'true') { v.muted = true; v.play().catch(function () {}); }
  }
  function init() {
    document.querySelectorAll('internal-video video, video').forEach(function (v) {
      if (v.querySelector('source[data-src]') || (v.closest('internal-video') && v.closest('internal-video').dataset.autoplay === 'true')) load(v);
      var btn = v.closest('internal-video') && v.closest('internal-video').querySelector('.internal-video__play');
      if (btn) btn.addEventListener('click', function () { v.muted = false; v.controls = true; v.play(); btn.style.display = 'none'; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
